import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class TransactionHistoryUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.getTransactionReport(req);
    }
}
export default TransactionHistoryUseCase;
